/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.1
 */

import Highlighter from 'react-highlight-words';

import { EllipseText } from '@components/common';
import { ILabelColor } from '@components/Table/constants/labelColor';

import { IMultiSelectLabelProps } from '../../MultiSelect';
import { IMultiSelectItem } from '../MultiSelectItemList';
import { LabelCellStyled, LabelSelectListStyled } from './styled/LabelSelectListStyled';

const LabelSelectList = (props: IMultiSelectLabelProps & IMultiSelectItem) => (
    <LabelSelectListStyled>
        <LabelCellStyled color={props.color}/>
        <EllipseText title={props.label}>
            <Highlighter
                autoEscape={true}
                highlightClassName="multiselect-item__label_highlight"
                searchWords={[props.searchValue]}
                textToHighlight={props.label}/>
        </EllipseText>
    </LabelSelectListStyled>
);

LabelSelectList.defaultProps = {
    color: ILabelColor.color7,
};

export default LabelSelectList;
